import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = [ 'container', 'backdrop' ]

  connect() {
    this.element[this.identifier] = this
    this.hiddenClass = 'hidden'
    this.closeEvent = 'popupClosed'
    this.openEvent = 'popupOpened'
    this.openOnStart = this.element.dataset.show == 'true'

    // Чтобы действие браузера "назад" закрывало модалку
    window.addEventListener('popstate', (event) => {
      if (!event.state || !event.state.modalOpen) {
        this.close(null, false)
      }
    })

    if (this.openOnStart) this.open()
  }

  disconnect() {
    this.close()
  }

  open(e = null, param = null) {
    if (e) e.preventDefault()

    this.containerTarget.classList.remove(this.hiddenClass)
    this.backdropTarget.classList.remove(this.hiddenClass)

    this._trigger(this.openEvent, param)
    this._scrollLock()

    window.history.pushState({ customNavigation: 'modal' }, '')
  }

  close(e = null, checkHistory = true) {
    if (e) e.preventDefault()

    this.containerTarget.classList.add(this.hiddenClass)
    this.backdropTarget.classList.add(this.hiddenClass)
    if (e && this.element.modalContent && !!this.element.modalContent.cancel) {
      this.element.modalContent.cancel()
    }

    if (this.openOnStart) this.element.remove()

    this._trigger(this.closeEvent)
    this._scrollUnlock()

    // Если закрывается через "назад" браузера, не триггерим заново
    if (checkHistory && window.history.state?.modalOpen) {
      window.history.back()
    }
  }

  closeContainer(e) {
    if (e.target == this.containerTarget) {
      this.close(e)
    }
  }

  closeWithEsc(e) {
    if (e.keyCode === 27 && !this.containerTarget.classList.contains(this.hiddenClass)) {
      this.close(e)
    }
  }

  _trigger(eventName, param = null) {
    const event = new CustomEvent(eventName, { bubbles: true, detail: { param: param } })
    window.dispatchEvent(event)
  }

  _scrollLock() {
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    document.body.style.paddingRight = `${scrollbarWidth}px`;
    this.scrollPosition = window.pageYOffset || document.body.scrollTop;
    document.body.classList.add('fixed', 'inset-x-0', 'overflow-hidden');
    document.body.style.top = `-${this.scrollPosition}px`;
  }

  _scrollUnlock() {
    document.body.style.paddingRight = null;
    document.body.classList.remove('fixed', 'inset-x-0', 'overflow-hidden');
    document.documentElement.scrollTop = this.scrollPosition;
    document.body.style.top = null;
  }
}
